/**
 * Polyfill mínimo para garantir compatibilidade do Axios com o navegador
 */

try {
  // Garantir que as APIs existam no window.global
  if (typeof window !== 'undefined') {
    if (!window.global) {
      window.global = window;
    }
  }
} catch (error) {
  console.error('[Polyfills] Erro:', error);
}

export default {};
